// Module Name
export const name = 'geolocation';

export const typeGeolocation = {
    GET_AUTOCOMPLETE: `${name}/GET_AUTOCOMPLETE`,
    GET_CLOSEST: `${name}/GET_CLOSEST`,
    GET_POINT_OF_INTEREST: `${name}/GET_POINT_OF_INTEREST`,
};
